import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const menuItems = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/#about" },
  { label: "Courses", to: "/#courses" },
  { label: "Videos", to: "/#videos" },
  { label: "Why Choose Us", to: "/#why-us" },
  { label: "Gallery", to: "/gallery" },
  { label: "Student Success", to: "/#designers" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact Us", to: "/#contact" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname, hash, key]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isActive = (item) => {
    if (item.to === "/") {
      return pathname === "/" && !hash;
    }

    if (item.to.startsWith("/#")) {
      return pathname === "/" && hash === item.to.slice(1);
    }

    return pathname === item.to;
  };

  const handleNavigation = (event, item) => {
    setMenuOpen(false);

    // Preserve normal Ctrl/Cmd-click and opening links in a new tab.
    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (item.to === "/" && pathname === "/" && !hash) {
      event.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;
    }

    // Scroll again when clicking the currently selected section.
    if (
      item.to.startsWith("/#") &&
      pathname === "/" &&
      hash === item.to.slice(1)
    ) {
      const section = document.getElementById(
        decodeURIComponent(item.to.split("#")[1]),
      );

      if (section) {
        event.preventDefault();

        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <header className="ltc-nav-header">
      <div className="ltc-nav-container">
        <Link
          to="/"
          className="ltc-nav-brand"
          aria-label="LifeTime Embroidery Design Class Home"
          onClick={(event) =>
            handleNavigation(event, { label: "Home", to: "/" })
          }
        >
          <span className="ltc-nav-logo-frame">
            <img src="/logo.jpg" alt="" className="ltc-nav-logo-image" />
          </span>

          <span className="ltc-nav-brand-copy">
            <span className="ltc-nav-brand-title">
              Life<span className="ltc-nav-brand-accent">Time</span>
            </span>

            <span className="ltc-nav-brand-subtitle">
              Embroidery Design Class
            </span>
          </span>
        </Link>

        <button
          type="button"
          className={`ltc-nav-toggle ${menuOpen ? "ltc-nav-toggle-open" : ""}`}
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
          aria-controls="ltc-nav-menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="ltc-nav-toggle-line" />
          <span className="ltc-nav-toggle-line" />
          <span className="ltc-nav-toggle-line" />
        </button>

        <nav
          id="ltc-nav-menu"
          className={`ltc-nav-menu ${menuOpen ? "ltc-nav-menu-open" : ""}`}
          aria-label="Main navigation"
        >
          <ul className="ltc-nav-list">
            {menuItems.map((item) => {
              const active = isActive(item);

              return (
                <li key={item.to} className="ltc-nav-item">
                  <Link
                    to={item.to}
                    className={`ltc-nav-link ${
                      active ? "ltc-nav-link-active" : ""
                    }`}
                    aria-current={active ? "location" : undefined}
                    onClick={(event) => handleNavigation(event, item)}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </header>
  );
}
